import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { AlertCircle, Check, DollarSign } from "lucide-react";

const CURRENCIES = [
  { value: "USD", label: "USD – Dólar Estadounidense" },
  { value: "COP", label: "COP – Peso Colombiano" },
  { value: "EUR", label: "EUR – Euro" },
  { value: "CNY", label: "CNY – Yuan Chino" },
];

interface Props {
  onSave: (currency: string) => Promise<void>;
}

export function CurrencyQuickFix({ onSave }: Props) {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<string>("");
  const [saving, setSaving] = useState(false);

  const handleConfirm = async () => {
    if (!selected) return;
    setSaving(true);
    try {
      await onSave(selected);
      setOpen(false);
      setSelected("");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className="inline-flex cursor-pointer" onClick={(e) => e.stopPropagation()}>
          <Badge variant="destructive" className="text-[10px] px-1.5 py-0 animate-pulse cursor-pointer hover:opacity-80 transition-opacity">
            FALTA MONEDA
          </Badge>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-0" align="start" side="bottom" onClick={(e) => e.stopPropagation()}>
        <div className="space-y-3 p-4">
          <div className="space-y-1">
            <div className="flex items-center gap-1.5 text-xs font-medium text-destructive">
              <AlertCircle className="h-3.5 w-3.5" />
              <span>Moneda no asignada</span>
            </div>
            <p className="text-[11px] text-muted-foreground leading-snug">
              La moneda es obligatoria para el cálculo de costos y nacionalización.
            </p>
          </div>

          <div className="space-y-1.5 rounded-md border border-amber-200 bg-amber-50 dark:border-amber-800 dark:bg-amber-950/30 p-3">
            <div className="flex items-center gap-1.5 text-xs font-medium text-amber-700 dark:text-amber-400">
              <DollarSign className="h-3.5 w-3.5" />
              <span>Asignar Divisa</span>
            </div>
            <Select value={selected} onValueChange={setSelected}>
              <SelectTrigger className="h-8 text-xs">
                <SelectValue placeholder="Seleccionar moneda…" />
              </SelectTrigger>
              <SelectContent>
                {CURRENCIES.map((c) => (
                  <SelectItem key={c.value} value={c.value} className="text-xs">
                    {c.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <Button
              size="sm"
              className="w-full mt-1"
              disabled={!selected || saving}
              onClick={handleConfirm}
            >
              <Check className="h-3.5 w-3.5 mr-1.5" />
              {saving ? "Guardando…" : "Confirmar"}
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
